<template>
    <div>
        <a-modal :width="700" :maskClosable="false" :visible="addCompany" :title="opCompany == 'add' ? '创建公司信息' : '修改公司信息'" :confirmLoading="spinning" @ok="submit" @cancel="closeModal">
            <a-spin :spinning="spinning">
                <a-form-model ref="companyForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
                    <a-form-model-item label="公司/组织名称" prop="name" :whitespace="true">
                        <a-input v-model="form.name" placeholder="请输入公司/组织名称" :maxLength="20" />
                    </a-form-model-item>
                    <a-form-model-item label="选择区域" prop="region">
                        <a-cascader :options="options" v-model="form.region" placeholder="选择区域" changeOnSelect @change="onChange" />
                    </a-form-model-item>
                    <a-form-model-item label="详细地址" prop="address">
                        <a-input v-model="form.address" placeholder="请输入公司/组织详细地址" :maxLength="20" />
                    </a-form-model-item>
                    <a-form-model-item label="联系人" prop="contactName">
                        <a-input v-model="form.contactName" placeholder="请输入联系人" :maxLength="5" />
                    </a-form-model-item>
                    <a-form-model-item label="联系电话" prop="contactPhone">
                        <a-input v-model="form.contactPhone" placeholder="请输入电话号码" :maxLength="11"/>
                    </a-form-model-item>
                    <a-form-model-item label="公司LOGO" prop="logoUrl">
                        <a-upload :action="baseUrl" list-type="picture-card" :before-upload="beforeImgUpload" :file-list="fileList" @preview="handlePreview" @change="handlechange">
                            <div v-if="fileList.length < 1">
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传图片
                                </div>
                            </div>
                        </a-upload>
                    </a-form-model-item>
                    <a-form-model-item label="公司介绍" prop="introduction">
                        <a-textarea :auto-size="{ minRows: 5, maxRows: 8 }" v-model="form.introduction" placeholder="请输入公司介绍" :maxLength="300" />
                    </a-form-model-item>
                </a-form-model>
            </a-spin>
        </a-modal>
        <Vviewer ref="viewer"></Vviewer>
    </div>
</template>
<script>
import options from "../../../utils/common/cascader-address-options";
import Vviewer from "../../../components/Vviewer";

options.map((provinceItem) => {
    provinceItem.value = provinceItem.label;
    provinceItem.children.map((cityItem) => {
        cityItem.value = cityItem.label;
        cityItem.children.map((districtItem) => {
            districtItem.value = districtItem.label;
        });
    });
});
export default {
    props: ["addCompany", "closeAddCompany", "opCompany"],
    components:{
        Vviewer,
    },
    data() {
        const _this = this;
        let chekckPic = (rule, value, callback) => {
            if (_this.fileList.length == 0) {
                callback(new Error("请上传LOGO图片"));
            } else {
                callback();
            }
        };
        let chekckName = (rule,value,callback)=>{
            let reg = new RegExp(/^[\u4E00-\u9FA5A-Za-z]+$/g)
            if(!reg.test(value) || value.length == 0){
                callback("请输入用户名称，并不要使用数字");
                return;
            }
            else{
                callback();
            }
        };
        let chekckContactName = (rule,value,callback)=>{
            let reg = new RegExp(/^[\u4e00-\u9fa5]{0,}$/g);
            if(!reg.test(value) || value.length == 0){
                callback("请输入联系人，并只能使用汉字");
                return
            }else{
                callback();
            }
        };
        return {
            spinning: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            baseUrl: process.env.VUE_APP_RESOURCES_API_HOST,
            baseImgUrl: process.env.VUE_APP_RESOURCES_HOST,
            fileList: [],
            labelAll: [],
            options: options,
            form: {
                name: "",
                address: "",
                region: [],
                introduction: "",
                contactName: "",
                contactPhone: "",
                logoUrl: "",
            },
            rules: {
                name: [{ required: true, trigger: "change",validator:chekckName}],
                region: [{ required: true, trigger: "blur", message: "请输入地址" }],
                contactName: [{ required: true, trigger: "change", validator: chekckContactName}],
                contactPhone: [
                    { required: true, trigger: "change", message: "请输入电话" },
                    { len: 11, message: "请输入正确的手机号码", pattern: /^1[3456789]\d{9}$/ },
                ],
                logoUrl: [{ required: true, message: "请上传LOGO图片", validator: chekckPic, trigger: "submit" }],
            },
            previewVisible: false,
            previewImage: "",
            viewImg: "",
        };
    },
    //查看公司信息
    watch: {
        opCompany(data) {
            if (data != "add") {
                this.spinning = true;
                const _this = this;
                this.$http.get("/publishcompany/query?id=" + data).then((res) => {
                    _this.spinning = false;
                    _this.form = {
                        name: res.data.name,
                        region: [res.data.province ? res.data.province : "", res.data.city ? res.data.city : "", res.data.district ? res.data.district : ""],
                        introduction: res.data.introduction,
                        contactName: res.data.contactName,
                        contactPhone: res.data.contactPhone,
                        address: res.data.address,
                    };
                    _this.fileList = [
                        {
                            uid: "-1",
                            name: "image.png",
                            status: "done",
                            url: this.baseImgUrl + res.data.logoUrl,
                            logoUrl: res.data.logoUrl,
                        },
                    ];
                });
            }
        },
    },
    //创建或修改公司信息
    methods: {
        //上传图片判定条件
        beforeImgUpload(file) {
            return new Promise((resolve, reject) => {
                var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
                const isLt2M = file.size / 1024 / 1024 <= 2; //图片大小不超过2MB
                if (!testmsg) {
                    this.$message.error("只支持上传图片");
                    return reject(false);
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过2MB!");
                    return reject(false);
                }
                return resolve(true);
            });
        },
        //查看大图
        async handlePreview(file) {
            if(file.response && file.response != ""){
                    this.$refs.viewer.show([
                    {
                      thumbnail:process.env.VUE_APP_RESOURCES_HOST+file.response.data.filePath,
                      source:process.env.VUE_APP_RESOURCES_HOST+file.response.data.filePath,
                    },
                ]);
                }else{
                  this.$refs.viewer.show([
                    {
                      thumbnail:process.env.VUE_APP_RESOURCES_HOST+file.logoUrl,
                      source:process.env.VUE_APP_RESOURCES_HOST+file.logoUrl,
                    },
                ]);
            }
        },
        //关闭预览
        handleCancel() {
            this.previewVisible = false;
        },
        //上传图片
        async handlechange({ file, fileList }) {
            if (file.status == "done" && file.response.rescode == 200) {
                fileList.map((item) => {
                    if (item.status == "done") {
                        if (item.response.data.coverImgUrl && item.response.data.coverImgUrl != "") {
                            item.thumbUrl = process.env.VUE_APP_RESOURCES_HOST + item.response.data.coverImgUrl;
                        }
                    }
                });
            } else if (file.status == "done" && file.response.rescode == 201) {
                this.$message.warning(file.response.msg);
                fileList = fileList.filter((item) => {
                    return item.uid != file.uid;
                });
            }
            this.fileList = fileList;
        },

        submit() {
            const _this = this;
            this.$refs.companyForm.validate((valid) => {
                if (valid) {
                    _this.spinning = true;
                    if (_this.opCompany == "add") {
                        let params = {
                            name: _this.form.name,
                            province: _this.form.region[0],
                            city: _this.form.region[1],
                            district: _this.form.region[2],
                            introduction: _this.form.introduction,
                            contactName: _this.form.contactName,
                            contactPhone: _this.form.contactPhone,
                            logoUrl: this.fileList[0].response.data.filePath,
                            address: _this.form.address,
                        };

                        _this.$http
                            .post("/publishcompany/add", params)
                            .then((res) => {
                                _this.$message.success("操作成功");
                                this.fileList = [];
                                _this.closeModal();
                            })
                            .catch((err) => {
                                _this.spinning = false;
                            });
                    } else {
                        let params = {
                            id: _this.opCompany,
                            name: _this.form.name,
                            province: _this.form.region[0],
                            city: _this.form.region[1],
                            district: _this.form.region[2],
                            introduction: _this.form.introduction,
                            contactName: _this.form.contactName,
                            contactPhone: _this.form.contactPhone,
                            address: _this.form.address,
                            logoUrl: this.fileList[0].response ? this.fileList[0].response.data.filePath : this.fileList[0].logoUrl,
                        };
                        _this.$http
                            .post("/publishcompany/update", params)
                            .then((res) => {
                                _this.$message.success("操作成功");
                                _this.closeModal();
                            })
                            .catch((err) => {
                                _this.spanning = false;
                            });
                    }
                }
            });
        },
        closeModal() {
            this.spinning = false;
            this.$refs.companyForm.resetFields();
            this.fileList = [];
            this.closeAddCompany();
        },
        onChange(e) {
            console.log(e);
        },
    },
};
</script>
<style scoped>
.StyleputIn {
    width: 128px;
    height: 128px;
}
</style>
